import { v4 as uuidv4 } from 'uuid';
import { regenTokenifExpired } from './utilityFunctions';
// get image and return promise
async function getImage(imgURL) {
  // const token = localStorage.getItem('token');
  const token = await regenTokenifExpired();
  const response = await fetch(imgURL, {
    headers: {
      Authorization: token,
      uuid: uuidv4(),
      audience: 'public',
    },
    credentials: 'omit',
  });
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result.split(',')[1];
      resolve(base64data);
    };
    reader.onerror = reject;
  });
}

// get base64 of image
async function getImageAsBase64(imgURL) {
  const base64data = await getImage(imgURL);
  return base64data;
}

// to get downloadable file from content-svc
async function fetchFileData(url) {
  // const token = localStorage.getItem('token');
  const token = await regenTokenifExpired();
  const response = await fetch(url, {
    headers: {
      Authorization: token,
      uuid: uuidv4(),
      audience: 'public',
    },
    credentials: 'omit',
  });
  const data = await response.blob();
  return data;
}

export { getImageAsBase64, fetchFileData };
